module.exports = __webpack_public_path__ + "img/pdf_styled_demo.fd1156d8.png";